import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { onAuthStateChanged, getIdToken } from "firebase/auth";
import { auth } from "./lib/firebase";
import { setTokenProvider } from "./lib/apiClient";
import { installAxiosResilience } from "./lib/installAxiosResilience";
import { installSessionResilience } from "./lib/sessionResilience";

// Global axios resilience: controlled handling of backend 503 / no-primary /
// network outages — degraded-state tracking, GET backoff, no fake success.
installAxiosResilience();

// DR-013: session resilience — sleep/resume + network-restore token refresh (single-flight) +
// proactive near-expiry refresh, broadcasting crm:session-recover for the WS layer to reconnect.
installSessionResilience();

// Provide Firebase ID token to API client (CRM architecture compliant)
setTokenProvider(async () => {
  const user = auth.currentUser;
  if (!user) return null;
  return await getIdToken(user, /* forceRefresh */ false);
});

// Optional: react to auth changes (token pulled lazily by apiClient)
onAuthStateChanged(auth, async () => {
  // No-op by design
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
